<template functional>
  <div :class="[
    data.class,
    data.staticClass
  ]">
    <div>
      <a href="https://www.hrsa.gov/" class="hrsa-logo">HRSA Health Resources and Services Administration</a>
    </div>
    <div class="social-media-links d-flex">
      <a href="https://www.facebook.com/HRSAgov/" class="fb-media-link">Facebook</a>
      <a href="https://twitter.com/HRSAgov" class="tw-media-link">Twitter</a>
      <a href="https://www.youtube.com/user/HRSAtube" class="yt-media-link">YouTube</a>
      <a href="https://www.linkedin.com/company/us-government-department-of-health-&amp;-human-services-hrsa"
        class="li-media-link"
      >LinkedIn</a>
      <a href="https://www.instagram.com/hrsagov" class="ig-media-link">Instagram</a>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.hrsa-logo {
  background-image: url('../../assets/hrsa-logo-white.svg'), linear-gradient(transparent, transparent);
  background-repeat: no-repeat;
  background-size: 140px 45px;
  display: block;
  height: 45px;
  margin-bottom: 1.5rem;
  overflow: hidden;
  width: 140px;
}

.social-media-links a {
  background-position: 50% 50%;
  background-repeat: no-repeat;
  display: block;
  height: 26px;
  margin-right: 0.75rem;
  opacity: 0.9;
  overflow: hidden;
  width: 26px;
}

.fb-media-link { background-image: url('../../assets/icon-facebook.svg'); }
.tw-media-link { background-image: url('../../assets/icon-twitter.svg'); }
.yt-media-link { background-image: url('../../assets/icon-youtube.svg'); }
.li-media-link { background-image: url('../../assets/icon-linkedin.svg'); }
.ig-media-link { background-image: url('../../assets/icon-instagram.svg'); }

.hrsa-logo, .social-media-links a {
  &:before {
    content: '';
    display: block;
    height: 150%;
    width: 0;
  }
}
</style>
